import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  adiNumber: Yup.string()
    .min(6, "ADI Number is too short (minimum is 6 characters)")
    .max(10, "ADI Number is too long (maximum is 10 characters)")
    .required("This field is required"),
  password: Yup.string().required("This field is required"),
});

export default validationSchema;
